var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":'mobile-pdf-viewer-'}})])
}
var staticRenderFns = []

export { render, staticRenderFns }